import { InsightType } from './IInsight';
import {
    ArrowTrendUpIcon,
    DiamondOutlineIcon,
    LightbulbOutlineIcon,
    SquareDashedIcon,
    IconComponent
} from '../theme/Icons';

// Plain-English label + icon + accent color for each insight type. The raw enum values (anomaly, gap...)
// are internal jargon; a caregiver should never be told they have an "anomaly", so these translate to
// warm, calm wording. The api's reflection prompt quotes these labels when it tags a finding, so that
// the type it picks matches the stance the caregiver reads — reword one of them here and the prompt
// needs the same wording. "anomaly" is a diamond rather than a warning triangle deliberately: the
// design forbids alarmist framing, and some anomalies are wellbeing/symptom escalations we must not turn
// into a hazard. The color tints the type pill each surface renders.
export const insightTypeMeta = (type: InsightType): { label: string; Icon: IconComponent; color: string; noteIntro: string } => {
    switch (type) {
        case 'trend':
            return { label: 'Trend', Icon: ArrowTrendUpIcon, color: '#11789D', noteIntro: 'Bea spotted a trend' };
        case 'anomaly':
            return { label: 'Stands out', Icon: DiamondOutlineIcon, color: '#923DAC', noteIntro: 'Bea noticed something that stands out' };
        case 'recommendation':
            return { label: 'Suggestion', Icon: LightbulbOutlineIcon, color: '#059669', noteIntro: 'Bea has a suggestion' };
        case 'gap':
            return { label: 'Worth watching', Icon: SquareDashedIcon, color: '#A16207', noteIntro: 'Bea found something worth watching' };
    }
    // The API deploys separately from the app, so a type this build doesn't know can reach us.
    // Degrade to a neutral pill instead of letting every consumer's destructure throw.
    return { label: 'Insight', Icon: LightbulbOutlineIcon, color: '#687f87', noteIntro: 'Bea noticed something' };
};
